export enum CATEGORY_STATUS {
  ADDING_ERROR = 'ADDING_ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
}

export type CategoryGetViewModel = {
  id: number;
  isActive: boolean;
  name: string;
  noOfDocs: number;
  noOfDocsInPath: number;
  status: CATEGORY_STATUS;
};

export type CategoryAddViewModel = {
  isActive: boolean;
  name: string;
  parentId: number;
};

export type CategoryModifyViewModel = {
  isActive: boolean;
};

export enum CATEGORIES_QUERY {
  GET_CATEGORIES = 'GET_CATEGORIES',
}
